import { render, staticRenderFns } from "./orgPersonMgr.vue?vue&type=template&id=0780f92a"
import script from "./orgPersonMgr.vue?vue&type=script&lang=js"
export * from "./orgPersonMgr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports